import { albumItemActionTypes } from './album-item-action-types';
import { authorizedRequest } from '../../common/request';
import {albumActionTypes} from "./album-action-types";
import {requestAlbum,albumItemsRemoved} from "./album-actions"

export const requestAlbumItems = (dispatch, customCollectionId, offset = 0, amIfetching = true, max = 10, type="any" ) => {
	if(amIfetching){
		return{
			type: albumItemActionTypes.ALBUM_ITEMS_REQUEST_WAIT,
			customerCollectionId: customCollectionId

		};
	}
	else{
	authorizedRequest(`${process.env.REACT_APP_WEB_API_URI}/sec/v1/ccs/${customCollectionId}/cces?offset=${offset}&max=${max}&type=${type}`)
		.then(data => dispatch(albumItemsReceived(data, customCollectionId)))
		.catch(error => dispatch(albumItemsFailed(error)));

	return {
		type: albumItemActionTypes.ALBUM_ITEMS_REQUEST,
		customerCollectionId: customCollectionId,
		offset
	};
}
};

export const rotateAlbumItem = (dispatch, id, rotation)=> {
	authorizedRequest(`${process.env.REACT_APP_WEB_API_URI}/sec/v1/rotate/cce/${id}/${rotation}`)
		.then(() => dispatch(rotateItemSuccess(id, rotation)))
		.catch(error => dispatch(rotateItemError(error)));

	return {
		type: albumItemActionTypes.ALBUM_ITEM_ROTATE_REQUEST
	};
};

const rotateItemSuccess = (id, rotation) => {
	return {
		type: albumItemActionTypes.ALBUM_ITEM_ROTATE_SUCCESS,
		id,
		rotation
	};
};

const rotateItemError = error => {
	return {
		type: albumItemActionTypes.ALBUM_ITEM_ROTATE_ERROR,
		error
	};
};
export const requestAlbumItemUpdate = (dispatch, id, updateData) => {
	authorizedRequest(`${process.env.REACT_APP_WEB_API_URI}/sec/v1/cces/${id}`, updateData, 'PUT')
		.then(() => dispatch(albumItemUpdated(id)))
		.catch(error => dispatch(albumItemUpdateFailed(error)));

	return {
		type: albumItemActionTypes.ALBUM_ITEM_UPDATE_REQUEST
	};
};

export const requestAlbumItem = (dispatch, id) => {
	authorizedRequest(`${process.env.REACT_APP_WEB_API_URI}/sec/v1/cces/${id}?format=deep` )
		.then(data => dispatch(albumItemDownload(data)))
		.catch(error => dispatch(albumItemDownloadFailed(error)));

	return {
		type: albumItemActionTypes.ALBUM_ITEM_DOWNLOAD_REQUEST
	};
};

export const requestAlbumItemDelete = (dispatch, id) => {
	authorizedRequest(`${process.env.REACT_APP_WEB_API_URI}/sec/v1/cces/${id}`, null, 'DELETE')
		.then(() => dispatch(albumItemDeleted(id)))
		.catch(error => dispatch(albumItemDeleteFailed(error)));

	return {
		type: albumItemActionTypes.ALBUM_ITEM_DELETE_REQUEST
	};
};

export const requestAlbumItemsDelete = (dispatch, ids) => {
	authorizedRequest(`${process.env.REACT_APP_WEB_API_URI}/sec/v1/cces`, ids, 'DELETE')
		.then(() => dispatch(albumItemDeleted(ids)))
		.catch(error => dispatch(albumItemDeleteFailed(error)));

	return {
		type: albumItemActionTypes.ALBUM_ITEM_DELETE_REQUEST
	};
};


export const requestAddAlbumItemsToAlbum = (dispatch, albumId, ids, deleteOriginal = false) => {
	authorizedRequest(`${process.env.REACT_APP_WEB_API_URI}/sec/v1/ccs/${albumId}/add/cces?deleteOriginal=${deleteOriginal}`, ids, 'PUT')
		.then(data=>{
			dispatch(requestAlbum(dispatch,albumId))
			if(deleteOriginal){
				dispatch(albumItemsRemoved(ids))
			}
		})
		.catch(error=>dispatch(addAlbumItemsToAlbumError(error)));
};

export const requestAddAlbumItemsToPhotoCD = (dispatch, photoCDId, ids) => {
	authorizedRequest(`${process.env.REACT_APP_WEB_API_URI}/sec/v1/pcdpkg/${photoCDId}/add/cces`, ids, 'PUT')
		.then(data=>dispatch(addAlbumItemsToPhotoCDSuccess(data)))
		.catch(error=>dispatch(addAlbumItemsToPhotoCDError(error)));
};

export const requestAddAlbumItemsToDvd = (dispatch, dvdId, ids) => {
	authorizedRequest(`${process.env.REACT_APP_WEB_API_URI}/sec/v1/dvdpkg/${dvdId}/add/dvdchaps`)
		.then(data=>dispatch(addAlbumItemsToDvdSuccess(data)))
		.catch(error=>dispatch(addAlbumItemsToDvdError(error)));
};

export const requestAlbumShallow = (dispatch, id) => {
	authorizedRequest(`${process.env.REACT_APP_WEB_API_URI}/sec/v1/ccs/${id}?format=deep`)
		.then(albumData => dispatch(albumReceived(albumData)))
		.catch(error => { 
			dispatch(albumRequestFailed(error));
		});

	return {
		type: albumItemActionTypes.ALBUM_PARENT_REQUEST
	};
};

const albumReceived = album => {
	return {
		type: albumItemActionTypes.ALBUM_PARENT_RECEIVED,
		album: album
	};
};

const albumRequestFailed = error => {
	return {
		type: albumItemActionTypes.ALBUM_PARENT_FAILED,
		error: error
	};
};


export const clearAlbumItems = () => {
	return {
		type: albumItemActionTypes.CLEAR_ALBUM_ITEMS
	};
};

export const clearAlbumItemsOffset = () => {
	return {
		type: albumItemActionTypes.CLEAR_ALBUM_ITEMS_OFFSET
	};
};

export const selectAlbumItem = albumItemId => {
	return {
		type: albumItemActionTypes.ALBUM_ITEM_SELECTED,
		albumItemId: albumItemId
	};
};

export const clearSelectedAlbumItems = () => {
	return {
		type: albumItemActionTypes.CLEAR_ALBUM_ITEM_SELECTION
	};
};

export const deselectAlbumItem = albumItemId => {
	return {
		type: albumItemActionTypes.ALBUM_ITEM_DESELECTED,
		albumItemId: albumItemId
	};
};

export const favoriteAlbums = (dispatch, ids, doFavorite) => {
	ids.forEach(id => {
		dispatch(requestAlbumItemUpdate(dispatch, id, { favoriteYn: doFavorite ? 'Y' : 'N' }));
	});

	return {
		type: albumItemActionTypes.ALBUM_ITEMS_UPDATE_REQUESTED
	};
};

export const deleteAlbumItems = (dispatch, ids) => {
	
		dispatch(requestAlbumItemsDelete(dispatch, ids));


	return {
		type: albumItemActionTypes.ALBUM_ITEM_DELETE_REQUESTS
	};
};
export const downloadAlbumItems = (dispatch, ids) => {
	ids.forEach(id=> {
		dispatch(requestAlbumItem(dispatch, id));
	});

	return {
		type: albumItemActionTypes.ALBUM_ITEM_DOWNLOAD
	};
};

export const albumItemsReceived = (albumItems, customCollectionId) => {
	if(albumItems == null || albumItems.results == null){
		return {
			type: "BAD_REQUEST"
		}
	}
	return {
		type: albumItemActionTypes.ALBUM_ITEMS_RECEIVED,
		albumItems: albumItems.results,
		offsetStart: parseInt(albumItems.offset, 10),
		offset: parseInt(albumItems.offset, 10) + albumItems.results.length,
		collectionId: parseInt(customCollectionId, 10),
		max: parseInt(albumItems.max, 10),
		count: albumItems.count,
        isComplete: albumItems.offset + albumItems.results.length === albumItems.count,
    	ids: typeof(albumItems.ids) === "undefined"?[]:albumItems.ids
	};
};

export const sliderItemsReceived = (albumItems, customCollectionId, reverse) => {
	return {
		type: albumItemActionTypes.ALBUM_ITEMS_SLIDER_RECEIVED,
		albumItems: albumItems.results,
        offsetStart: parseInt(albumItems.offset, 10),
		offset: parseInt(albumItems.offset, 10) + (albumItems.results == null ? 0 : albumItems.results.length),
		isComplete: true,
		collectionId: parseInt(customCollectionId, 10),
		max: parseInt(albumItems.max, 10),
		count: albumItems.count,
		isReversed: reverse
	};
};

export const showingAlbumId = id => {
	return {
		type: albumItemActionTypes.ALBUM_SHOW,
		id 
	};
};

export const mouseHover = hover => {
	return {
		type: albumItemActionTypes.ALBUM_ITEM_HOVER,
		hover 
	};
};

export const sliderItemsFailed = error => {
	return {
		type: albumItemActionTypes.ALBUM_ITEMS_SLIDER_FAILED,
		isComplete: true,
		error: error
	};
};
export const albumItemsFailed = error => {
	return {
		type: albumItemActionTypes.ALBUM_ITEMS_FAILED,
		error: error
	};
};

export const albumItemUpdated = (id,albumItem) => {
	return {
		type: albumItemActionTypes.ALBUM_ITEM_UPDATED,
		id: id,
		albumItem: albumItem
	};
};

const albumItemUpdateFailed = error => {
	return {
		type: albumItemActionTypes.ALBUM_ITEM_UPDATE_FAILED,
		error: error
	};
};

const albumItemDownload = data => {
	
	const url = data.downloads.PHOTO_ORIGINAL;
	if(url.indexOf('http') > -1){
	window.open(url);
	}
	return {
		type: albumItemActionTypes.ALBUM_ITEM_DOWNLOAD_REQUEST,
		url
	};

};

export const albumItemDownloadFailed = error => {
	return {
		type: albumItemActionTypes.ALBUM_ITEM_DOWNLOAD_FAILED,
		error
	};

};


const albumItemDeleted = ids => {
	return {
		type: albumItemActionTypes.ALBUM_ITEM_DELETED,
		ids
	};
};

const albumItemDeleteFailed = error => {
	return {
		type: albumItemActionTypes.ALBUM_ITEM_DELETE_FAILED,
		error: error
	};
};

const addAlbumItemsToAlbumSuccess = data => {
	return {
		type: albumItemActionTypes.ALBUM_ITEMS_ADD_TO_ALBUM_SUCCESS,
		data: data
	};
};

const addAlbumItemsToAlbumError = error => {
	return {
		type: albumItemActionTypes.ALBUM_ITEMS_ADD_TO_ALBUM_FAILURE,
		error: error
	};
};

const addAlbumItemsToPhotoCDSuccess = data => {
	return {
		type: albumItemActionTypes.ALBUM_ITEMS_ADD_TO_PHOTOCD_SUCCESS,
		data: data
	};
};

const addAlbumItemsToPhotoCDError = error => {
	return {
		type: albumItemActionTypes.ALBUM_ITEMS_ADD_TO_PHOTOCD_FAILED,
		error: error
	};
};

const addAlbumItemsToDvdSuccess = data => {
	return {
		type: albumItemActionTypes.ALBUM_ITEMS_ADD_TO_DVD_SUCCESS,
		data: data
	};
};

const addAlbumItemsToDvdError = error => {
	return {
		type: albumItemActionTypes.ALBUM_ITEMS_ADD_TO_DVD_FAILED,
		error: error
	};
};
export const getAlbumItemInArrayById = (albumArray, id) => {
    for(let i=0;i<albumArray.length;i++){
        if(albumArray[i].id === id){
            return albumArray[i];
        }
    }
    return null;
}

export const recordScrollPosition = (scrollPosition) =>{
    return {
        type: albumItemActionTypes.ALBUM_ITEM_SCROLL,
        scrollPosition: scrollPosition
    }
}


// WEBPACK FOOTER //
// ./src/album-view/actions/album-item-actions.js